<ion-select *ngIf="field.field_type === 7" [(ngModel)]="field.value">
  <ng-container *ngFor="let alphanumCode of alphanumCodes">
    <ion-select-option  [value]="alphanumCode.code">
      {{ alphanumCode.code_ml | caption }}
    </ion-select-option>
  </ng-container>
</ion-select>

<ion-select *ngIf="field.field_type === 8" [(ngModel)]="field.value" interface="action-sheet">
  <ng-container *ngFor="let alphanumCode of alphanumCodes">
    <ion-select-option [value]="alphanumCode.code">
      {{ alphanumCode.code_ml | caption }}
    </ion-select-option>
  </ng-container>
</ion-select>

<ion-list *ngIf="field.field_type === 9">
  <ion-item *ngFor="let alphanumCode of alphanumCodes">
    <ion-label>{{alphanumCode.code_ml | caption}}</ion-label>
    <ion-checkbox slot="start" [value]="alphanumCode.code" (ionChange)="onCheckBoxChange(alphanumCode.code)"></ion-checkbox>
  </ion-item>
</ion-list>